import { Barcode } from "lucide-react";
import type { FC } from "react";
import React from "react";

import { Button } from "@react/ui-primitives/button";

import { Logo } from "../../../shared/components/Logo.tsx";

interface EmptyStateProps {
  readonly onScanBarcode: () => void;
}

export const EmptyState: FC<EmptyStateProps> = ({ onScanBarcode }) => (
  <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 px-6 text-center">
    <Logo className="size-7 text-[hsl(225deg_15%_78%)]" />
    <p className="text-sm font-semibold text-foreground">Your field is empty</p>
    <p className="max-w-[244px] text-[12.5px] text-pretty text-muted-foreground">
      Scan a barcode, snap a receipt, or enter it by hand — every square is a
      piece of your day.
    </p>
    <Button className="mt-1 gap-[7px]" onClick={onScanBarcode}>
      <Barcode className="size-[15px]" />
      Scan a barcode
    </Button>
  </div>
);
